import { render, staticRenderFns } from "./riskResult.vue?vue&type=template&id=df2cb35e"
import script from "./riskResult.vue?vue&type=script&lang=js"
export * from "./riskResult.vue?vue&type=script&lang=js"
import style0 from "./riskResult.vue?vue&type=style&index=0&id=df2cb35e&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df2cb35e')) {
      api.createRecord('df2cb35e', component.options)
    } else {
      api.reload('df2cb35e', component.options)
    }
    module.hot.accept("./riskResult.vue?vue&type=template&id=df2cb35e", function () {
      api.rerender('df2cb35e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/security/riskResult.vue"
export default component.exports